































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator'
import TextAnswerComponent from '@/modules/chatbot/components/answers/TextAnswerComponent.vue'
import SuggestionsAnswerComponent from '@/modules/chatbot/components/answers/SuggestionsAnswerComponent.vue'
import SelectableAnswerComponent from '@/modules/chatbot/components/answers/SelectableAnswerComponent.vue'
import PhoneAnswerComponent from '@/modules/chatbot/components/answers/PhoneAnswerComponent.vue'
import { DialogService } from '@/modules/chatbot/services/dialog.service'
import { TextAnswer, SelectableAnswer, SuggestionAnswer, PhoneAnswer } from '@/modules/chatbot/controllers/Chat'
import { getModule } from 'vuex-module-decorators'
import { ChatStore } from '@/modules/chatbot/store'

  @Component({
    components: { SelectableAnswerComponent, SuggestionsAnswerComponent, TextAnswerComponent, PhoneAnswerComponent }
    // computed: mapState('chat', ['selectedQuestion']) this would work, but causes issues with the typing on the component
  })
export default class ChatBot extends Vue {
    name: 'ChatBot'
    chatStore = getModule(ChatStore, this.$store)

    colors = ['#000000', '#385F73', '#00FA9A']
    messages = [{ side: 1, message: 'Sea usted bienvenido' }, { side: 1, message: 'Me llamo Geoffrey 🤵🏿, su nuevo y fiel mayordomo' }, { side: 1, message: '¿que tal?' }, { side: 2, message: 'bien, aqui encerrado' }, { side: 1, message: 'pues ya somos dos 😷' }]
    typeQuestion: string = ''

    errorResponseCounter : number = 0
    static LIMIT_ERROR_RESPONSE: number = 4 // If the errorResponseCounter arribes until this amount, we show how to get human help

    get selectedQuestion () {
      return this.chatStore.selectedQuestion
    }

    addMessage (message) : any {
      this.messages.push({ side: 2, message: message })
      this.chatStore.nextQuestion()
      this.messages.push({ side: 1, message: this.selectedQuestion.question })

      if (this.chatStore.selectedQuestionIndex === this.chatStore.dialog.questions.length - 1) {
        this.chatStore.sendAnswers()
      }
    }

    showErrorMessage (message): any {
      if (this.errorResponseCounter >= ChatBot.LIMIT_ERROR_RESPONSE) {
        // TODO improve, this is just for demo
        this.messages.push({ side: 1,
          message: 'I are sorry, I am still learning and probably now you want to contact with our humans, ' +
            'please send a message to help@leadproquo.com, or contact us via twitter (link) or slack (link) ' +
            'and they will happy to help you' })
        this.errorResponseCounter = 0
      } else {
        this.messages.push({ side: 1, message: message })
        this.errorResponseCounter++
      }
    }

    async created () {
      let dialogs = await DialogService.list(1, 5)
      console.log(dialogs)
      this.chatStore.setDialog(dialogs[1])
      this.messages.push({ side: 1, message: this.selectedQuestion.question })
    }

    destroyed () {
      // TODO temp, when the chat finish it should restart or go to somewhere else
      this.chatStore.setDialog(this.chatStore.dialog)
    }

    @Watch('selectedQuestion', { immediate: true, deep: true })
    onSelectedQuestionChange () {
      if (this.selectedQuestion == null) {
        this.typeQuestion = ''
        return
      }
      switch (true) {
        case this.selectedQuestion && this.selectedQuestion.answer == null:
          this.typeQuestion = ''
          this.chatStore.nextQuestion()
          this.messages.push({ side: 1, message: this.selectedQuestion.question })
          break
        case this.selectedQuestion.answer instanceof TextAnswer:
          this.typeQuestion = 'textAnswer'
          break
        case this.selectedQuestion.answer instanceof SelectableAnswer:
          this.typeQuestion = 'selectableAnswer'
          break
        case this.selectedQuestion.answer instanceof SuggestionAnswer:
          this.typeQuestion = 'suggestionAnswer'
          break
        case this.selectedQuestion.answer instanceof PhoneAnswer:
          this.typeQuestion = 'phoneAnswer'
          break
      }
    }
}
